import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { WmsOrderDetailDto, WmsOrderHeaderDto } from "src/dtos/wmsOrder/wmsOrderDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface KSK1070_R01Dto {
	wmsOrderHeaderDto: KSK1070_R01HeaderDto;
	wmsOrderDetailDtoList: KSK1070_R01DetailDto[];
	
	wmsStockLotDtoList: Record<string, KSK1070_R01LotDto[]>;
}

export interface KSK1070_R01HeaderDto extends WmsOrderHeaderDto {
	warehouseNm: string;
}

export const defaultKSK1070_R01HeaderDto: KSK1070_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	wmsOrderNo: '',
	compCd: '',
	compNm: '',	
	logicCenter: '',
	orderDt: formatDate(new Date()),
	inoutType: '',
	inoutClass: '110', // 입고구분값 110으로 고정(구매입고)
	customCd: '',
	customNm: '',
	deadlineDt: formatDate(new Date()),
	inoutMethod: '',
	empNo: '',
	empNm: '',
	orderAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	inoutStatus: '',
	approveFlg: '',
	closeTag: 'N',
	remark: '',

	warehouseCd: '', // 창고코드
	warehouseNm: '', // 창고명

	inserted: false,
	isModified: false
}

// WMS 주문 상세 DTO (DetailBaseDto 요구사항 충족)
export interface KSK1070_R01DetailDto extends WmsOrderDetailDto {
	dcAmt: number; // DetailBaseDto 요구사항 충족
	cancelQty: number;
	// 기입고량, 여기서 기입고량을 입력하고 입고량을 업데이트 하고 백엔드에 전송
	updateTransportQty: number; 
	orderQtyView: number;
	/** 품목 보관위치(로케이션) - 라벨 storageLocation용 */
	locationCd?: string;
	locationNm?: string;
	packQty: number;
}


export const defaultKSK1070_R01DetailDto: KSK1070_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	wmsOrderNo: '',
	itemNo: '',
	itemNm: '',
	itemSpec: '',
	modelNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	orderDt: formatDate(new Date()),
	itemSeq: 0,
	itemCd: '',
	itemStatus: '',
	orderUnit: '',
	orderQty: 0,
	cancelQty: 0,
	orderPrice: 0,
	orderAmt: 0,
	transportQty: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',

	updateTransportQty: 0,	// 입고합계 : 기입고량, 여기서 기입고량을 입력하고 입고량을 업데이트 하는 수량을 백엔드에 전송
	dcAmt: 0,				// DetailBaseDto 요구사항 충족
	orderQtyView: 0,		// 주문잔량 : 주문량 - 기입고량 - 취소수량 조회용
	locationCd: '',
	locationNm: '',
	packQty: 0,

	inserted: false,
	isModified: false
}

export interface KSK1070_R01LotDto extends WmsStockLotDto {
	lotInputOption: string;
	printed: boolean;  // 라벨 출력 여부
}

export const defaultKSK1070_R01LotDto: KSK1070_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	lotCreateDt: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	lotInputOption: 'N',
	printed: false,  // 라벨 출력 여부 기본값

	inserted: false,
	isModified: false,
}
